import { FieldSchemaFormBuilderV2, SchemaFactoryV2 } from "@ucl/library";
import { buildComplexFieldKey, COMPLEX_FIELD_KEYS, FIELD_KEYS, MODEL_KEYS } from "@/constants";
import { PersonInformationComplexField } from "../ComplexFields";
import { PersonalAccountBeneficiary } from "@/types";
import { FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export const createPersonalAccountBeneficiaryFormBuilder = (
  schemaFactory: SchemaFactoryV2,
  executionContextType: FinancialApplicationFormSectionContextType
): FieldSchemaFormBuilderV2<PersonalAccountBeneficiary> => {
  return (onValueChange, form, errors) => {
    const applicantRequiredFields: string[] = [
      FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.RELATIONSHIP_TO_PRIMARY_OWNER,

      // Person Information Complex Fields
      buildComplexFieldKey(
        FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.PERSON_INFORMATION,
        COMPLEX_FIELD_KEYS.PERSON_INFORMATION.FIRST_NAME
      ),
      buildComplexFieldKey(
        FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.PERSON_INFORMATION,
        COMPLEX_FIELD_KEYS.PERSON_INFORMATION.LAST_NAME
      ),
      buildComplexFieldKey(
        FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.PERSON_INFORMATION,
        COMPLEX_FIELD_KEYS.PERSON_INFORMATION.DATE_OF_BIRTH
      ),
    ];

    const bankerRequiredFields: string[] = [
      ...applicantRequiredFields,

      // Person Information Complex Fields
      buildComplexFieldKey(
        FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.PERSON_INFORMATION,
        COMPLEX_FIELD_KEYS.PERSON_INFORMATION.SOCIAL_SECURITY_NUMBER
      ),
    ];

    const requiredFields =
      executionContextType === FinancialApplicationFormSectionContextType.Banker
        ? [...bankerRequiredFields]
        : executionContextType === FinancialApplicationFormSectionContextType.Applicant
          ? [...applicantRequiredFields]
          : [];

    const fields = [
      ...schemaFactory.buildModelSchema<PersonalAccountBeneficiary>(
        MODEL_KEYS.PERSONAL_ACCOUNT_BENEFICIARY,
        onValueChange,
        form,
        errors,
        requiredFields,
        {
          PersonInformationExpressionSchema: PersonInformationComplexField,
        }
      ),
    ];

    return fields;
  };
};
